
interface DeleteBrgDialogProps {
  brgName: string;
  isOpen: boolean;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteBrgDialog({
  isOpen,
  isDeleting,
  onConfirm,
  onCancel,
}: DeleteBrgDialogProps) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="delete-dialog-title"
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '8px',
          maxWidth: '480px',
          width: '90%',
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <div
          style={{
            backgroundColor: '#0078d4',
            padding: '14px 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h2
            id="delete-dialog-title"
            style={{ margin: 0, fontSize: '1.1rem', color: '#fff', display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            <span>⚠</span> Confirm BRG Deletion
          </h2>
          <button
            onClick={onCancel}
            disabled={isDeleting}
            aria-label="Close"
            style={{
              background: 'none',
              border: 'none',
              color: '#fff',
              fontSize: '1.2rem',
              cursor: 'pointer',
              lineHeight: 1,
              padding: '0 4px',
            }}
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: '24px 28px' }}>
          <p style={{ margin: '0 0 24px', color: '#333', lineHeight: 1.6, textAlign: 'center' }}>
            Are you sure you want to delete this BRG?
            <br />
            This action is permanent and cannot be undone. All associated data
            <br />
            will be permanently removed.
          </p>

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
            <button
              onClick={onConfirm}
              disabled={isDeleting}
              style={{
                padding: '9px 32px',
                border: 'none',
                borderRadius: '4px',
                backgroundColor: '#0078d4',
                color: '#fff',
                cursor: isDeleting ? 'wait' : 'pointer',
                fontSize: '0.95rem',
                fontWeight: 600,
                minWidth: '120px',
              }}
            >
              {isDeleting ? 'Deleting...' : 'Confirm'}
            </button>
            <button
              onClick={onCancel}
              disabled={isDeleting}
              style={{
                padding: '9px 32px',
                border: 'none',
                borderRadius: '4px',
                backgroundColor: '#0078d4',
                color: '#fff',
                cursor: isDeleting ? 'not-allowed' : 'pointer',
                fontSize: '0.95rem',
                fontWeight: 600,
                minWidth: '120px',
              }}
            >
              CANCEL
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
